var map = {
	"./bird.png": 58,
	"./bird_1.png": 59,
	"./bird_2.png": 60,
	"./bird_3.png": 61,
	"./bird_4.png": 62,
	"./cat.png": 63,
	"./cat_1.png": 64,
	"./cat_2.png": 65,
	"./cat_3.png": 66,
	"./cat_4.png": 67,
	"./dog.png": 68,
	"./dog_1.png": 69,
	"./dog_2.png": 70,
	"./dog_3.png": 71,
	"./dog_4.png": 72,
	"./frog.png": 73,
	"./frog_1.png": 74,
	"./frog_2.png": 75,
	"./frog_3.png": 76,
	"./frog_4.png": 77,
	"./hedgehog.png": 78,
	"./hedgehog_1.png": 79,
	"./hedgehog_2.png": 80,
	"./hedgehog_3.png": 81,
	"./hedgehog_4.png": 82,
	"./rabit.png": 83,
	"./rabit_2.png": 84,
	"./rabit_3.png": 85,
	"./rabit_4.png": 86,
	"./rabit_5.png": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;